// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"250":"f7b3e11a","453":"41119028","968":"77029f1a"}[chunkId] + ".chunk.js";
};